import { StandardError, StandardErrors } from '@/util/StandardErrors';
import ErrorKey from '@/util/ErrorKey';
import { getModule } from 'vuex-module-decorators';
import { ErrorStore } from '@/stores/error.store';
import { AxiosResponse } from 'axios';
import store from '@/stores/index';

export interface StoreResponse<T> {
  success: boolean;
  payload?: T;
  error?: StandardError;
}

export const StoreResponses = {
  error<T>(rawError: any, fallbackKey: ErrorKey): StoreResponse<T> {
    const wrappedError = StandardErrors.wrapIfUnknown(rawError, fallbackKey);
    // tslint:disable-next-line:no-console
    console.warn(
      'Store responded with error', rawError,
      'translated to', ErrorKey[wrappedError.errorKey],
      'with parameters', wrappedError.parameters,
    );
    return this.standardError(wrappedError);
  },
  standardError<T>(error: StandardError): StoreResponse<T> {
    const errorStore = getModule(ErrorStore, store);
    errorStore.setError(error);
    return {success: false, error};
  },
  forErrorKey<T>(errorKey: ErrorKey, ...parameters: string[]): StoreResponse<T> {
    return StoreResponses.error({errorKey, parameters}, errorKey);
  },
  success<T>(payload: T): StoreResponse<T> {
    return {success: true, payload};
  },
  suppressedError<T>(rawError: any, fallbackKey: ErrorKey): StoreResponse<T> {
    const wrappedError = StandardErrors.wrapIfUnknown(rawError, fallbackKey);
    const errorStore = getModule(ErrorStore, store);
    errorStore.dismissStandardError(wrappedError);
    return {success: false, error: wrappedError};
  },
  apiSuccess<T>(reponse: AxiosResponse<T>): StoreResponse<T> {
    return StoreResponses.success(reponse.data);
  },
};
